export default "__VITE_ASSET__BtHOzECp__"